import { Injectable } from '@angular/core';
import { TransferState } from '@angular/platform-browser';

import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { BrandContentModel } from './models/brand.model';
import { BrandContentResponse } from './models/brand-response.model';


@Injectable({
  providedIn: 'root',
})
export class BrandContentService extends BaseGQLService<BrandContentResponse> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: BrandContentModel,
        clientName: 'BrandContentService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryBrandContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState
    );
  }


}


